export default function step1() {
    // sygdom
    this.textareaCounter();
    this.singleDatePicker('.bootstrap-datepicker');
    window.SygemeldtFraArbejdeDatoLastValue = '';

    App.ipvalidationAuto.init();
    window.saveandnext = function (a) {

        return App.ipvalidationAuto.IPValidateElementsScrollToErr('.ipvalidateenabled:visible');
    };

    $(window).on('singleDatePickerChanged', function (evnt, o) { setValidationOk(o); });

    const elm = document.querySelector('.jsHvornaarblevdusyg');
    elm.addEventListener('focusout', function (e) {
        window.ValidateSygemeldtFraArbejdeDatoPre(elm.value, 40);
    });

    window.ValidateSygemeldtFraArbejdeDatoTS = 0;
    window.ValidateSygemeldtFraArbejdeDatoPre = function (stringDate, n) {
        if (window.ValidateSygemeldtFraArbejdeDatoTS) {
            clearTimeout(window.ValidateSygemeldtFraArbejdeDatoTS);
            window.ValidateSygemeldtFraArbejdeDatoTS = 0;
        }
        if (window.SygemeldtFraArbejdeDatoLastValue == stringDate) {
            return;
        }
        window.ValidateSygemeldtFraArbejdeDatoTO = this.setTimeout(function () { window.ValidateSygemeldtFraArbejdeDatoTS = 0; window.ValidateSygemeldtFraArbejdeDato(stringDate); }, n);
    };

    window.ValidateSygemeldtFraArbejdeDato = function (stringDate) {
        if (window.SygemeldtFraArbejdeDatoLastValue == stringDate || stringDate == '') {
            return;
        }
        elm.parentNode.parentNode.classList.remove('info');
        window.SygemeldtFraArbejdeDatoLastValue = stringDate;

        const url = '/api/sitecore/TabErhvervsevne/ArbejdeValidateSygemeldtFraArbejdeDato';
        const urlData = url + '?stringDate=' + encodeURI(stringDate);

        fetch(urlData)
            .then(
                function (response) {
                    if (response.status !== 200) {
                        return;
                    }
                    return response;
                }
            )
            .then(function (response) { return response.json(); })
            .then(function (data) {

                var theDate = data;
                if (theDate.ok) {
                    elm.parentNode.parentNode.classList.remove('info');
                } else {
                    elm.parentNode.parentNode.classList.add('info');
                }
            })
            .catch(function (err) {
                console.log('Fetch Error :-S', err); // eslint-disable-line
            });

    };

}
